/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
    AssetsMelcoModelsHoopCategory,
    AssetsMelcoModelsHoopCategoryFromJSON,
    AssetsMelcoModelsHoopCategoryFromJSONTyped,
    AssetsMelcoModelsHoopCategoryToJSON,
    AssetsMelcoModelsHoopMachine,
    AssetsMelcoModelsHoopMachineFromJSON,
    AssetsMelcoModelsHoopMachineFromJSONTyped,
    AssetsMelcoModelsHoopMachineToJSON,
    AssetsMelcoModelsHoopProduct,
    AssetsMelcoModelsHoopProductFromJSON,
    AssetsMelcoModelsHoopProductFromJSONTyped,
    AssetsMelcoModelsHoopProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsHoop
 */
export interface AssetsMelcoModelsHoop {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    english_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    metric_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsHoop
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsHoop
     */
    width_points?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsHoop
     */
    height_points?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    presser_foot?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetsMelcoModelsHoop
     */
    enable_templates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    backward_compatibility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    supplier_product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    supplier_product_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    english_dimensions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    metric_dimensions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    asset_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetsMelcoModelsHoop
     */
    discontinued?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    melco_pn?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsHoop
     */
    publish_state?: number;
    /**
     * 
     * @type {Array<AssetsMelcoModelsHoopCategory>}
     * @memberof AssetsMelcoModelsHoop
     */
    category_list?: Array<AssetsMelcoModelsHoopCategory> | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsHoopProduct>}
     * @memberof AssetsMelcoModelsHoop
     */
    product_list?: Array<AssetsMelcoModelsHoopProduct> | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsHoopMachine>}
     * @memberof AssetsMelcoModelsHoop
     */
    machine_list?: Array<AssetsMelcoModelsHoopMachine> | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsHoop
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsHoop
     */
    published_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsHoop
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    asset?: string | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsHoop
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoop
     */
    signature?: string | null;
}

export function AssetsMelcoModelsHoopFromJSON(json: any): AssetsMelcoModelsHoop {
    return AssetsMelcoModelsHoopFromJSONTyped(json, false);
}

export function AssetsMelcoModelsHoopFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsHoop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'english_name': !exists(json, 'english_name') ? undefined : json['english_name'],
        'metric_name': !exists(json, 'metric_name') ? undefined : json['metric_name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'width_points': !exists(json, 'width_points') ? undefined : json['width_points'],
        'height_points': !exists(json, 'height_points') ? undefined : json['height_points'],
        'presser_foot': !exists(json, 'presser_foot') ? undefined : json['presser_foot'],
        'enable_templates': !exists(json, 'enable_templates') ? undefined : json['enable_templates'],
        'backward_compatibility_id': !exists(json, 'backward_compatibility_id') ? undefined : json['backward_compatibility_id'],
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'supplier_product_id': !exists(json, 'supplier_product_id') ? undefined : json['supplier_product_id'],
        'supplier_product_name': !exists(json, 'supplier_product_name') ? undefined : json['supplier_product_name'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'english_dimensions': !exists(json, 'english_dimensions') ? undefined : json['english_dimensions'],
        'metric_dimensions': !exists(json, 'metric_dimensions') ? undefined : json['metric_dimensions'],
        'asset_type': !exists(json, 'asset_type') ? undefined : json['asset_type'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'discontinued': !exists(json, 'discontinued') ? undefined : json['discontinued'],
        'melco_pn': !exists(json, 'melco_pn') ? undefined : json['melco_pn'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'category_list': !exists(json, 'category_list') ? undefined : (json['category_list'] === null ? null : (json['category_list'] as Array<any>).map(AssetsMelcoModelsHoopCategoryFromJSON)),
        'product_list': !exists(json, 'product_list') ? undefined : (json['product_list'] === null ? null : (json['product_list'] as Array<any>).map(AssetsMelcoModelsHoopProductFromJSON)),
        'machine_list': !exists(json, 'machine_list') ? undefined : (json['machine_list'] === null ? null : (json['machine_list'] as Array<any>).map(AssetsMelcoModelsHoopMachineFromJSON)),
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'published_date': !exists(json, 'published_date') ? undefined : (json['published_date'] === null ? null : new Date(json['published_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
    };
}

export function AssetsMelcoModelsHoopToJSON(value?: AssetsMelcoModelsHoop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'english_name': value.english_name,
        'metric_name': value.metric_name,
        'version': value.version,
        'width_points': value.width_points,
        'height_points': value.height_points,
        'presser_foot': value.presser_foot,
        'enable_templates': value.enable_templates,
        'backward_compatibility_id': value.backward_compatibility_id,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'supplier_product_id': value.supplier_product_id,
        'supplier_product_name': value.supplier_product_name,
        'name': value.name,
        'english_dimensions': value.english_dimensions,
        'metric_dimensions': value.metric_dimensions,
        'asset_type': value.asset_type,
        'type': value.type,
        'discontinued': value.discontinued,
        'melco_pn': value.melco_pn,
        'publish_state': value.publish_state,
        'category_list': value.category_list === undefined ? undefined : (value.category_list === null ? null : (value.category_list as Array<any>).map(AssetsMelcoModelsHoopCategoryToJSON)),
        'product_list': value.product_list === undefined ? undefined : (value.product_list === null ? null : (value.product_list as Array<any>).map(AssetsMelcoModelsHoopProductToJSON)),
        'machine_list': value.machine_list === undefined ? undefined : (value.machine_list === null ? null : (value.machine_list as Array<any>).map(AssetsMelcoModelsHoopMachineToJSON)),
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'published_date': value.published_date === undefined ? undefined : (value.published_date === null ? null : value.published_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'asset': value.asset,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
        'signature': value.signature,
    };
}


